/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Preload video using a promise.
 *
 * @param {string} src Video source.
 * @return {Promise} Video object.
 */
const preloadVideoMetadata = (src) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.onloadedmetadata = () => resolve(video);
    video.onerror = () =>
      reject(new Error('Failed to load metadata for video with src: ' + src));
    video.crossOrigin = 'anonymous';
    video.src = src;
    video.muted = true;
  });
};

export default preloadVideoMetadata;
